import { Img, Section, Text } from '@react-email/components';

export const EmailHeader = () => {
  return (
    <Section style={{ marginBottom: '24px' }}>
      <Img src="https://web.lingaai.com/logo.png" alt="Linga AI" width="32" height="32" style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '10px' }} />
      <Text
        style={{
          fontSize: '20px',
          fontWeight: '600',
          color: '#174a43',
          margin: '0',
          display: 'inline-block',
          verticalAlign: 'middle',
          fontFamily: "'Figtree', Arial, sans-serif",
        }}
      >
        Linga AI
      </Text>
    </Section>
  );
};
